export default "__VITE_ASSET__7903ff87__"